import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import '../../styles/CommonStyles.css';

function PrivacyPolicyPage() {
  return (
    <div className="page-container">
      <Header />
      
      <div className="page-header">
        <h1>PRIVACY POLICY</h1>
        <p>Learn how Bangalore Valuers' Association handles your personal information</p>
      </div>
      
      <section className="content-section">
        <div className="legal-container" style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div className="last-updated" style={{ 
            fontSize: '0.9rem', 
            fontStyle: 'italic', 
            marginBottom: '2rem',
            color: '#666'
          }}>
            Last Updated: June 30, 2025
          </div>

          <div className="policy-section">
            <h2>INTRODUCTION</h2>
            <p>
              Bangalore Valuers' Association ("BVA," "we," "our," or "us") respects your privacy and is committed to 
              protecting your personal information. This Privacy Policy explains how we collect, use, disclose, 
              and safeguard your information when you visit our website or use our services.
            </p>
            <p>
              Please read this Privacy Policy carefully. By accessing or using our services, you acknowledge that 
              you have read, understood, and agree to be bound by all the terms outlined in this policy. If you do 
              not agree with our policies and practices, please do not use our services.
            </p>
          </div>

          <div className="policy-section">
            <h2>INFORMATION WE COLLECT</h2>
            <p>We collect several types of information from and about users of our services, including:</p>
            <h3>Personal Information</h3>
            <ul>
              <li>Contact information (such as name, email address, mailing address, phone number)</li>
              <li>Professional information (such as job title, company, professional qualifications)</li>
              <li>Profile information (such as username and password, profile picture)</li>
              <li>Payment information (such as credit card details, billing address)</li>
              <li>Membership information (such as membership type, renewal dates, membership history)</li>
            </ul>

            <h3>Usage Information</h3>
            <ul>
              <li>Device information (such as IP address, browser type, operating system)</li>
              <li>Log information (such as access times, pages viewed, time spent on site)</li>
              <li>Location information (such as general geographic location based on IP address)</li>
              <li>Activity information (such as events attended, resources accessed)</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>HOW WE COLLECT INFORMATION</h2>
            <p>We collect information from you when you:</p>
            <ul>
              <li>Register for membership</li>
              <li>Create an account on our website</li>
              <li>Subscribe to our newsletter</li>
              <li>Register for events or programs</li>
              <li>Purchase products or services</li>
              <li>Submit a professional listing</li>
              <li>Complete surveys or forms</li>
              <li>Contact us through our website</li>
              <li>Interact with our website or services</li>
            </ul>
            
            <p>
              We also collect information through cookies and similar tracking technologies. For more 
              information about our use of cookies, please see the "Cookies and Tracking Technologies" 
              section below.
            </p>
          </div>

          <div className="policy-section">
            <h2>HOW WE USE YOUR INFORMATION</h2>
            <p>We use the information we collect about you for various purposes, including to:</p>
            <ul>
              <li>Process membership applications and renewals</li>
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send administrative information, such as updates to our terms and policies</li>
              <li>Send promotional communications, such as newsletters and event announcements</li>
              <li>Respond to your inquiries and provide customer support</li>
              <li>Conduct research and analysis to improve our services</li>
              <li>Customize your experience on our website</li>
              <li>Protect our services and users from fraudulent or illegal activity</li>
              <li>Comply with legal obligations</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>DISCLOSURE OF YOUR INFORMATION</h2>
            <p>We may disclose your personal information in the following circumstances:</p>
            <ul>
              <li><strong>Service Providers:</strong> We may share your information with third-party service providers who perform services on our behalf, such as payment processing, data analysis, email delivery, and website hosting.</li>
              <li><strong>Professional Directory:</strong> If you choose to be listed in our professional directory, the information you provide will be made publicly available to visitors of our website.</li>
              <li><strong>Legal Requirements:</strong> We may disclose your information if required to do so by law or in response to valid requests by public authorities.</li>
              <li><strong>Business Transfers:</strong> We may share or transfer your information in connection with a merger, acquisition, reorganization, or sale of all or a portion of our assets.</li>
              <li><strong>With Your Consent:</strong> We may disclose your information for any other purpose with your consent.</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>DATA SECURITY</h2>
            <p>
              We have implemented measures designed to secure your personal information from accidental loss and from 
              unauthorized access, use, alteration, and disclosure. All information you provide to us is stored on secure 
              servers behind firewalls.
            </p>
            <p>
              Unfortunately, the transmission of information via the internet is not completely secure. Although we do our 
              best to protect your personal information, we cannot guarantee the security of your personal information 
              transmitted to our website. Any transmission of personal information is at your own risk.
            </p>
          </div>

          <div className="policy-section">
            <h2>COOKIES AND TRACKING TECHNOLOGIES</h2>
            <p>
              We use cookies and similar tracking technologies to track activity on our website and store certain information. 
              Cookies are files with small amounts of data that may include an anonymous unique identifier.
            </p>
            <p>
              We use cookies for various purposes, including to:
            </p>
            <ul>
              <li>Keep you signed in to our website</li>
              <li>Remember your preferences and settings</li>
              <li>Understand how you use our website</li>
              <li>Improve our services</li>
            </ul>
            <p>
              You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, 
              if you do not accept cookies, you may not be able to use some portions of our website.
            </p>
          </div>

          <div className="policy-section">
            <h2>YOUR RIGHTS AND CHOICES</h2>
            <p>
              You have certain rights and choices regarding your personal information:
            </p>
            <ul>
              <li><strong>Access and Update:</strong> You can access and update your personal information by logging into your account.</li>
              <li><strong>Marketing Communications:</strong> You can opt out of receiving marketing communications from us by following the unsubscribe instructions included in our emails.</li>
              <li><strong>Cookies:</strong> You can set your browser to refuse all or some browser cookies or to alert you when cookies are being sent.</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>CHILDREN'S PRIVACY</h2>
            <p>
              Our services are not intended for children under the age of 18. We do not knowingly collect personal information 
              from children under 18. If you are a parent or guardian and you believe your child has provided us with personal 
              information, please contact us so that we can take necessary actions.
            </p>
          </div>

          <div className="policy-section">
            <h2>CHANGES TO OUR PRIVACY POLICY</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new 
              Privacy Policy on this page and updating the "Last Updated" date at the top of this page.
            </p>
            <p>
              You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy 
              are effective when they are posted on this page.
            </p>
          </div>

          <div className="policy-section">
            <h2>CONTACT US</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <div style={{ margin: '1rem 0' }}>
              <p>
                <strong>Bangalore Valuers' Association</strong><br />
                Email: info@bangalorevaluers.org<br />
                Phone: +91 8088383543<br />
                Address: 522C, 1st D Cross, 15th Main, 3rd Stage, 4th Block,
                Basaveshwaranagar, Bangalore - 560 079 Karnataka State, INDIA
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}

export default PrivacyPolicyPage;
